import { ref } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useApi } from '@/composables/useApi';
import { useKioskStore } from '@/stores/useKioskStore';

export const useTranslationsStore = defineStore('translations', () => {
	const { request } = useApi();
	const kioskStore = useKioskStore();

	const { kioskId } = storeToRefs(kioskStore);
	const translations = ref(null);
	const locale = ref('en');

	async function fetchTranslations(){
		const result = await request(`/api/${kioskId.value}/translation`);
		translations.value = result[locale.value];
	}

	return {
		locale,
		translations,
		fetchTranslations,
	};
});
